// extracted by mini-css-extract-plugin
module.exports = {"rating_3BuQel":"rating_3BuQel","star_3nDexP":"star_3nDexP","selected_1n-Gtt":"selected_1n-Gtt"};